import MaskedInput from 'react-text-mask'
import ShieldIcon from '@mortgage-pos/ui/assets/ShieldIcon.svg'
import React, {
  ChangeEventHandler,
  FocusEventHandler,
  FC,
  useState,
  useCallback,
} from 'react'

interface Props {
  name: string
  value: string
  title?: string
  onChange: ChangeEventHandler<HTMLInputElement>
  onBlur?: FocusEventHandler<HTMLInputElement>
}

const HORIZONTAL_BAR = String.fromCharCode(8213) // Like a dash, but a bit longer

const ssnMask = [
  /./,
  /./,
  /./,
  HORIZONTAL_BAR,
  /./,
  /./,
  HORIZONTAL_BAR,
  /./,
  /./,
  /./,
  /./,
]

const removeDashes = (str: string): string => str.replace(/[―-]/g, '') // this removes the HORIZONTAL_BAR as well as standard hyphen

const SsnInput: FC<Props> = ({
  name,
  value,
  onChange,
  onBlur = (e) => {},
  title,
  ...rest
}) => {
  const [showSsn, setShowSsn] = useState(false)
  const [localSsnValue, setLocalSsnValue] = React.useState<string | undefined>(
    value
  )

  const handleChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (e) => {
      const newValue = removeDashes(e.target.value)
      const newEvent: React.ChangeEvent<HTMLInputElement> = {
        ...e,
        target: {
          ...e.target,
          name,
          value: newValue,
        },
      }
      onChange(newEvent)
      setLocalSsnValue(newValue)
    },
    [name, onChange]
  )

  const handleShowButtonClick = () => {
    setShowSsn((prevSsn) => !prevSsn)
  }

  return (
    <div className="input__ssn-wrapper">
      <div className="input__ssn-input-wrapper">
        {showSsn ? (
          <MaskedInput
            mask={ssnMask}
            type="text"
            value={localSsnValue}
            guide={false}
            autoComplete="off"
            name={name}
            className="input__field --ssn fs-exclude"
            onChange={handleChange}
            onBlur={onBlur}
            maxLength="11"
            title={title}
            {...rest}
          />
        ) : (
          <input
            type="text"
            value={localSsnValue}
            autoComplete="off"
            name={name}
            className="input__field --ssn --hidden fs-exclude"
            onChange={handleChange}
            onBlur={onBlur}
            maxLength={9}
            title={title}
            {...rest}
          />
        )}
        <button
          type="button"
          onClick={handleShowButtonClick}
          className="input__ssn-show-button"
        >
          {showSsn ? 'Hide' : 'Show'}
        </button>
      </div>
      <div className="input__ssn-security-blurb">
        <img className="input__ssn-shield-icon" src={ShieldIcon} alt="Shield" />
        Protected with bank-level security
      </div>
    </div>
  )
}

export default SsnInput
